module.exports = __webpack_public_path__ + "media/images/common/send_btn_l-cf8afcef4a5f42c29d958d9e3211c304.png";